import moment from 'moment-timezone';
import { ValidDateFormats } from '../Shared/DateUtilities';

export type AuditEntity = {
    auditCreatedOn: string;
    auditLastUpdatedByUser: string;
    auditLastUpdated: string;
};

export function getAuditLine(auditedEntity: AuditEntity): string {
    return `Created ${moment(auditedEntity.auditCreatedOn).format(ValidDateFormats.Display)} · Last edited by ${
        auditedEntity.auditLastUpdatedByUser
    } · ${moment(auditedEntity.auditLastUpdated).fromNow()}`;
}
